import type {
  ContractCorrectableField,
  ContractEntryStatus,
  ContractFlag,
  ContractType,
} from '../api/types';

// The contract register (ADR-0054): the words every app shows. Facts only — what a
// document states and plain date comparisons; never "risky" or any other opinion.

export const CONTRACT_TYPE_LABELS: Record<ContractType, string> = {
  lease: 'Lease',
  customer_agreement: 'Customer agreement',
  supplier_agreement: 'Supplier agreement',
  insurance_policy: 'Insurance policy',
  license_permit: 'License / permit',
  loan_agreement: 'Loan agreement',
  employment_agreement: 'Employment agreement',
  other_agreement: 'Other agreement',
};

export const CONTRACT_FLAG_LABELS: Record<ContractFlag, string> = {
  expired: 'Expired',
  expires_within_90_days: 'Within 90 days',
  expires_before_closing: 'Before closing',
};

export const CONTRACT_STATUS_LABELS: Record<Exclude<ContractEntryStatus, 'extracted'>, string> = {
  pending: 'Being read',
  not_contract: 'Not the contract itself',
  no_text: 'No readable text',
};

export const CONTRACT_FIELD_LABELS: Record<ContractCorrectableField, string> = {
  effective_date: 'Effective',
  expiration_date: 'Expires',
  notice_by: 'Notice by',
  auto_renew: 'Auto-renew',
  counterparty: 'Counterparty',
};

/** "90 days" / "3 months". */
export function noticePeriodLabel(p: { count: number; unit: 'day' | 'month' } | null): string | null {
  if (!p) return null;
  return `${p.count} ${p.unit}${p.count === 1 ? '' : 's'}`;
}
